import RestApiModel from "@/api/Model/RestApiModel";

class ProductOwner extends RestApiModel {
  static getResourceEndpoint() {
    return '/product-owners';
  }
}

export default ProductOwner;
